'use client'

import { useUserPortfolio } from '@repo/services'
import {
  HistoryChanges,
  InformationDialog,
  ValueWithUnit,
} from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Card, Col, Row, Typography } from '@repo/ui/components'
import { WalletChart } from './wallet.chart'
import { WalletActions } from './wallet.actions'

export const WalletSidebarLayout = () => {
  const { t } = useTranslate()
  const { data: { data } = {}, isLoading, isFetching } = useUserPortfolio()
  const changes = [
    {
      label: t('common_change_24h'),
      value: data?.estimated?.delta24H?.amount ?? 0,
      percent: data?.estimated?.delta24H?.percent ?? 0,
    },
    {
      label: t('common_change_7d'),
      value: data?.estimated?.delta7D?.amount ?? 0,
      percent: data?.estimated?.delta7D?.percent ?? 0,
    },
    {
      label: t('common_change_30d'),
      value: data?.estimated?.delta30D?.amount ?? 0,
      percent: data?.estimated?.delta30D?.percent ?? 0,
    },
  ]

  return (
    <Card withoutBorder className='px-xs py-md'>
      <Col className=' gap-md text-neutral-surface-60 items-center'>
        <Row className='gap-2xs justify-center'>
          <Typography size='2xs' className='text-center'>
            {t('walletPage_total_value_label')}
          </Typography>
          <InformationDialog title={t('walletPage_total_value_label')}>
            {t('info_total_value')}
          </InformationDialog>
        </Row>

        <ValueWithUnit
          value={data?.estimated?.availableBalance}
          valueSize='xl'
          unitSize='md'
          unit='TMN'
          decimalPlaces={0}
          scale={10}
          loading={isLoading || isFetching || !data}
          loadingSize='w-34 h-2xl'
        />

        <WalletActions />
        <HistoryChanges changes={changes} />
        <WalletChart />
      </Col>
    </Card>
  )
}
